import React, {Component} from 'react'
import {Card, CardBody} from "reactstrap"
import OrdersReportFilters from './filters/OrdersReportFilters'
import OrdersReportActions from './actions/OrdersReportActions'
import OrdersReportTable from './table/OrdersReportTable'
import OrdersReportTotal from "./OrdersReportTotal"
import {listOrdersReport} from '../../services/api/apiOrdersReport'
import {getListSku} from "../../services/api/apiSku"
import moment from 'moment'
import NextPagination from "../../components/Pagination/NextPagination"

class OrdersReportPage extends Component {
    constructor(props) {
        super(props)

        const currentDay = new Date()
        const firstDay = new Date(currentDay.getFullYear(), currentDay.getMonth(), 1)

        this.state = {
            error: '',
            loading: false,
            orders: [],
            limit: 500,
            total: 0,
            page: 1,
            types: [],
            filters: {
                shipping_carrier: '',
                types: [],
                packaged_at: {
                    from: moment(firstDay).format('DD/MM/YYYY'),
                    to: moment(currentDay).format('DD/MM/YYYY')
                },
                source: ''
            }
        }
    }

    componentDidMount() {
        this._listOrdersReport()
        this._listTypes()
    }

    _listTypes = async () => {
        try {
            const payload = {
                limit: 1000,
                page: 1,
                sort: "name"
            }

            const {'data': responsive} = await getListSku(payload)

            const {success, data, message} = responsive

            if (!success) {
                throw new Error(message)
            }

            const {items} = data
            const listTypes = items.map(item => {
                return {
                    name: item.name,
                    value: item.sku
                }
            })

            this.setState({
                types: listTypes
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }

    _listOrdersReport = async () => {
        try {
            const {page, limit, filters, requestCount} = this.state
            const nextCount = requestCount ? requestCount + 1 : 1

            this.setState({
                loading: true,
                error: '',
                requestCount: nextCount
            })

            const newFilters = Object.assign({}, filters)

            if (newFilters.types.length === 0) {
                delete newFilters['types']
            }

            const payload = {
                ...newFilters,
                limit,
                page,
            }

            const {data: respons} = await listOrdersReport(payload)

            const {success, message, data} = respons

            if (nextCount !== this.state.requestCount) {
                return this.setState({
                    error: message,
                    loading: false,
                })
            }

            if (!success) return this.setState({
                orders: [],
                error: message,
                loading: false,
            })

            const {barcodes, total} = data

            this.setState({
                orders: barcodes,
                loading: false,
                total: total
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleChangeLimit = (limit) => {
        this.setState({
            limit: parseInt(limit),
            page: 1
        }, () => {
            this._listOrdersReport()
        })
    }

    _handleChangeFilter = (filters) => {
        this.setState({
            filters: {
                ...filters,
            },
            page: 1
        }, () => {
            this._listOrdersReport()
        })
    }

    _handleResetFilters = () => {
        this.setState({
            filters: {
                shipping_carrier: '',
                types: [],
            },
            page: 1
        }, () => {
            this._listOrdersReport()
        })
    }

    _handleChangePage = (page) => {
        this.setState({
            page: page
        }, () => {
            this._listOrdersReport()
        })
    }

    render() {
        const {orders, limit, filters, error, types, loading, total, page} = this.state

        return (
            <div className="OrdersReportPage">
                <Card>
                    <div className="CardHeader card-header header-elements-inline">
                        <div className="header-elements d-flex justify-content-between align-items-center w-100">
                            <h1 className='card-title'>Orders Report</h1>
                            <div className="actions">
                                <OrdersReportActions filters={filters} onResetFilters={this._handleResetFilters}/>
                            </div>
                        </div>
                    </div>

                    <CardBody>
                        <OrdersReportFilters
                            types={types}
                            filters={filters}
                            onChangeFilters={this._handleChangeFilter}
                        />
                        <div className="d-flex justify-content-end mb-3">
                            <OrdersReportTotal
                                limit={limit}
                                total={total}
                                onChangeLimit={this._handleChangeLimit}
                            />
                        </div>
                        <OrdersReportTable orders={orders} loading={loading} error={error}/>
                        <div className="mt-3 float-right">
                            <NextPagination
                                limit={limit}
                                total={total}
                                page={page}
                                onChange={this._handleChangePage}
                            />
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default OrdersReportPage
